
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {dictApi,mechanismApi} from "@/api/organization";
    import baseUrl, {ejianFrontUrl, imageUrl} from "@/constants";
    const {CodeToText} =require("@/js/region/region");
    import DialogPreview from "@/components/DialogPreview/index.vue";
    @Component({
      components: {DialogPreview}}
    )
    export default class organizationTable2 extends Vue {
        title = "单位信息简单版";
        baseUrl = baseUrl
        imageUrl = imageUrl
        CodeToText = CodeToText
        mechanismDetail = { //单位详情
            visible: false,
            detail: null as any,
            updateVisible: false,
        }
        iframeDialog = {
          title: '',
          visible: false,
          url: ''
        }
        mechanismTypeData = {}
        levelData = {}
        /**
         * 编辑的id
         * */
        @Prop() private id!: any;
        @Prop() private status!: any;
        @Prop() private manufacture!: any;
        @Prop() private organizationType!: any;
        created() {
            if(this.id){
                this.init();
            }
        }
        //是否是授权机构
        isAuthMechanism(){
            return this.mechanismDetail.detail.type.indexOf("0006") > -1 || this.mechanismDetail.detail.type.indexOf("0008") > -1;
        }
        init(){
            this.listDict();
            this.loadDetail();
        }
      onTag(mode: string, data: any){
        const firstRouterText = this.$route.path.split("/")[1];
        switch (mode) {
          case "standardCount": {
            this.iframeDialog.url = `/${firstRouterText}/measuring/list/This_Unit/CUR/Standard/${data.id}`;
            this.iframeDialog.title = '计量标准列表';
            this.iframeDialog.visible = true;
            break;
          }
          case "standardItemCount": {
            this.iframeDialog.url = `/${firstRouterText}/measuring/list/This_Unit/CUR/Item/${data.id}`;
            this.iframeDialog.title = '可开展项目列表';
            this.iframeDialog.visible = true;
            break;
          }
          case "publicStandardCount": {
            this.iframeDialog.url = `/${firstRouterText}/public/list/This_Unit/CUR/${data.id}`;
            this.iframeDialog.title = '社会公用计量标准列表';
            this.iframeDialog.visible = true;
            break;
          }
          case "certCount": {
            this.iframeDialog.url = `/${firstRouterText}/cert/list/This_Unit/CUR/AuthorizeCert/${data.id}`;
            this.iframeDialog.title = '授权证书列表';
            this.iframeDialog.visible = true;
            break;
          }
          case "certItemCount": {
            this.iframeDialog.url = `/${firstRouterText}/cert/list/This_Unit/CUR/AllItem/${data.id}`;
            this.iframeDialog.title = '授权项目列表';
            this.iframeDialog.visible = true;
            break;
          }
          case "instrCount": {
            this.iframeDialog.url = ejianFrontUrl + '/#/open/instr/index?orgId=' + data.id;
            this.iframeDialog.title = '器具列表';
            this.iframeDialog.visible = true;
            break;
          }
        }
        return;
      }
        loadDetail(){
            let api;
            const params = {
                size: 1,
                current: 1,
                organizationId: this.id,
                status: this.manufacture === '1'?'0':this.status,
                source: this.manufacture === '1'?'1':null
            }
            if(this.manufacture=="1"){
                api = mechanismApi.list3(params)
            }else{
                api = mechanismApi.getMechanismAndUser(this.id)
            }
            api.then(r => {
                if (r.data.result === 0) {
                    if(this.manufacture=="1"){
                        const rData = r.data.data.records;
                        if(rData.length > 0){
                            this.mechanismDetail.detail = rData[0];
                            this.mechanismDetail.visible = true;
                        }
                    }else{
                        this.mechanismDetail.detail = r.data.data;
                        this.mechanismDetail.visible = true;
                    }

                }
            })
        }
        listDict() {
            //单位类别
            dictApi.listDictItem({typeCode: "dwlb"}).then((r) => {
                if (r.data.result === 0) {
                    const mechanismTypeData = {} as any;
                    const dataList = r.data.data;
                    dataList.forEach((d: any) => {
                        mechanismTypeData[d.dictKey] = d;
                    });
                    mechanismTypeData['0005'] = {dictValue: '所在单位管理'}
                    this.mechanismTypeData = mechanismTypeData;
                }
            });

            //单位级别
            dictApi.listDictItem({typeCode: "dwjb"}).then((r) => {
                if (r.data.result === 0) {
                    const levelData = {} as any;
                    const dataList = r.data.data;
                    dataList.forEach((d: any) => {
                        levelData[d.dictKey] = d;
                    });
                    this.levelData = levelData;
                }
            });
        }
    }
